'use client';

/**
 * Main toast hook for general application toasts
 *
 * Uses the toast factory to create a toast system with counter-based IDs
 * and no auto-dismiss (toasts stay until manually dismissed).
 */

import type { ToastActionElement, ToastProps } from '@/components/ui/toast';
import { type BaseToastProps, createToastSystem } from './toast-factory';

// Toast props type that extends the UI component props
type ToasterToastProps = ToastProps &
  BaseToastProps & {
    action?: ToastActionElement;
  };

// Create toast system with counter-based IDs and no auto-dismiss
const { toast, useToast: useToastInternal } =
  createToastSystem<ToasterToastProps>({
    limit: 1,
    removeDelay: 1000000,
    defaultDuration: 0, // No auto-dismiss
    idGenerator: 'counter',
  });

// Re-export with proper types
function useToast() {
  return useToastInternal();
}

export { useToast, toast };
